import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { config } from '../config';
import { getSessionId } from './SessionCorrelation';
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: config.instrumentationKey,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: window.history },
        },
    },
});
appInsights.loadAppInsights();
// Cached user ID from ADO SDK, resolved lazily after SDK init
let _cachedHashId;
/**
 * Set the hashId (ADO user ID) to be included in all telemetry events.
 * Call this after ADO SDK initialization.
 */
export function setTelemetryHashId(hashId) {
    _cachedHashId = hashId;
}
// Tag every telemetry item with interfaceType and hashId
const interfaceType = window.location.href.toLowerCase().includes('hub') ? 'Hub' : 'Panel';
appInsights.addTelemetryInitializer((item) => {
    item.baseData = item.baseData || {};
    if (!item.baseData.properties)
        item.baseData.properties = {};
    item.baseData.properties.interfaceType = interfaceType;
    const sessionId = getSessionId();
    if (sessionId) {
        item.baseData.properties.sessionId = sessionId;
    }
    if (_cachedHashId) {
        item.baseData.properties.hashId = _cachedHashId;
    }
});
// Flush buffered telemetry before a full-page navigation/redirect (e.g. an MSAL
// sign-in redirect loop) so sign-in failure events aren't lost on unload.
window.addEventListener('pagehide', () => {
    try {
        const ai = appInsights;
        if (typeof ai.onunloadFlush === 'function')
            ai.onunloadFlush();
        else
            ai.flush?.(false);
    }
    catch {
        /* best-effort */
    }
});
export { reactPlugin, appInsights };
